export default "__VITE_ASSET__CYREKEo3__"